<!--
 * @Author: chenlin
 * @Date: 2019-09-12 09:02:21
 * @LastEditors: lzq
 * @LastEditTime: 2023-10-31 14:04:32
 * @Description: 本地、测试环境登录(不支持正式环境)
 -->
<template>
  <div class="login-page">
    <div class="login-conts">
      <div class="login-left"><img src="images/login-img.jpg" /></div>
      <div class="login-right">
        <p class="big-title">
          <img class="logo" src="images/logo.png" /><span class="tit">仓储管理系统</span>
        </p>
        <p class="title">用户登录</p>
        <el-form ref="loginForm" :rules="rules" :model="form">
          <el-form-item prop="username">
            <el-input placeholder="账号" type="text" v-model="form.username" prefix-icon="el-icon-user" clearable />
          </el-form-item>
          <el-form-item prop="password">
            <el-input placeholder="密码" @keyup.enter="goHome" type="password" v-model="form.password"
              prefix-icon="el-icon-lock" @keyup.enter.native="goHome" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="goHome()" :loading="loading">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router.js'
import store from '@/store'

export default {
  name: 'login',
  data() {
    return {
      form: {
        username: '',
        password: '',
        code: null,
        uuid: null,
        verification: false
      },
      loading: false,
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: ['change', 'blur'] }],
        password: [{ required: true, message: '请输入密码', trigger: ['change', 'blur'] }],
      }
    }
  },
  methods: {
    // 登录
    goHome() {
      this.loading = true
      this.$refs.loginForm.validate((valid) => {
        if (!valid) return
        this.$store
          .dispatch('Login', this.form)
          .then(async () => {
            await this.$store.dispatch('GetPermissions')
            console.log(store.getters)
            await this.$store.dispatch('GetInfo')
            this.$store.dispatch('GenerateRoutes').then((accessRoutes) => {
              router.addRoutes(accessRoutes) // 动态添加可访问路由表
              this.$router.push({ path: '/statistics' })
            })

          })
          .catch(() => { })
          .finally(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>
